import React from "react";
import './DemoPanel.scss'

import logo from './assets/images/logo-upordown_demo.png';
import device01 from './assets/images/demo-devices/iPhone X-1.png';
import device02 from './assets/images/demo-devices/iPhone X-2.png';
import device03 from './assets/images/demo-devices/iPhone X-3.png';
import device04 from './assets/images/demo-devices/iPhone X-4.png';
import device05 from './assets/images/demo-devices/iPhone X-5.png';

interface DemoPanelProps{
    onStyleChange : (id:number)=>void
}

export default class DemoPanel extends React.Component<DemoPanelProps>{

    componentDidMount = ()=>{
        for(let i = 0 ; i < 5;i++){
            const div = document.getElementById('device0' + i);
            div.style.marginLeft = `${-40 * i}px`;
            if(i !== 0 && (i + 1) % 2 === 0 )
                div.style.marginTop = `${70}px`;
        }
    }
    render(){
        return (
            <div className="demo-panel">
                    <img className="logo-demo" src={logo} alt="logo"></img>
                <div className="demo-buttons">
                    <img id="device00" className="device" alt="device 01" src={device01} onClick={()=>{this.props.onStyleChange(0)}}></img>
                    <img id="device01" className="device" alt="device 02" src={device02} onClick={()=>{this.props.onStyleChange(1)}}></img>
                    <img id="device02" className="device" alt="device 03" src={device03} onClick={()=>{this.props.onStyleChange(2)}}></img>
                    <img id="device03" className="device" alt="device 04" src={device04} onClick={()=>{this.props.onStyleChange(3)}}></img>
                    <img id="device04" className="device" alt="device 05" src={device05} onClick={()=>{this.props.onStyleChange(4)}}></img>
                </div>
            </div>
        )
    }
}